<div [class.mat-elevation-z2]="confirmClickRef.style === 'popover'" style="background: #fff; padding: 8px 16px">
  <h2 class="sg-color-disabled">{{data.title}}</h2>
  <p>{{data.description}}</p>
  @if (data.prompt; as prompt) {
  <div>
    <br />
    <sg-textarea
      [placeholder]="prompt.placeholder"
      [value]="promptValue"
      (valueChange)="promptValue = $event"
      [hideLabel]="true"
      [autoResize]="true"
      [minRows]="1"
      [maxRows]="5"
      width="100%"></sg-textarea>
  </div>
  }
  <div style="margin-top: 32px" class="sg-flex-row sg-justify-end sg-items-center sg-gap-16">
    <sg-button
      [text]="data.textCancel"
      (onClick)="close(false)"
      variant="ghost-secondary"
      [style.minWidth.px]="80"
      [fullWidth]="true"
      data-test="noBtn"></sg-button>
    <sg-button
      [text]="data.textOk"
      [disabled]="data.prompt?.isDisabled && data.prompt.isDisabled(promptValue)"
      (onClick)="close(true)"
      variant="primary"
      [style.minWidth.px]="80"
      [fullWidth]="true"
      data-test="yesBtn"></sg-button>
  </div>
</div>
